import { Input } from 'antd';
import { useTypedMask } from '@/hooks';

type TMaskedInputProps = {
  value?: string;
  onChange?: (value: string) => void;
  format: (digits: string) => string;
  maxDigits: number;
  placeholder?: string;
  inputMode?: 'numeric' | 'tel';
  size?: 'large' | 'middle' | 'small';
  normalizeDigits?: (digits: string) => string;
};

const MaskedInput = ({ value, onChange, format, maxDigits, placeholder, inputMode, size, normalizeDigits }: TMaskedInputProps) => {
  const { inputRef, displayValue, onFocus, onBlur, onKeyDown, onPaste } = useTypedMask({
    format,
    maxDigits,
    value,
    onChange,
    normalizeDigits,
  });

  return (
    <Input
      ref={inputRef}
      value={displayValue}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      onChange={() => {}}
      placeholder={placeholder}
      inputMode={inputMode}
      size={size}
    />
  );
};

export default MaskedInput;
